import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';
//import Request from '../../utils/request';

const NAME = 'LocationText';

const generateUrl = (query = "") => window.location.origin + window.location.pathname + query;

class LocationText extends BaseComponent {
	constructor(element) {
		super(element);
		this.position = {
			latitude: LTA_DEFAULT_LOCATION.latitude,
			longitude: LTA_DEFAULT_LOCATION.longitude
		};
		this.Cookies = undefined;
		this.trigger = SelectorEngine.findOne('.js-geolocation-trigger', element);
		this.text = SelectorEngine.findOne('.js-geolocation-location', element);
		this.noSearch = SelectorEngine.findOne('.no-search', element);
		this.useLoader = LOADER_PAGES.includes(window.location.pathname);
		this.key = 'AIzaSyDyzGpEphEVl2MRq76Y6Y9VL32JGQr2heg';
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		// eslint-disable-next-line promise/catch-or-return
		this.initCookiesLib();
		this.initGeolocation();

		// Hide component if geolocation is not supported

		if (!navigator.geolocation) {
			this.classList.add('u-hidden');
		}

		EventHandler.on(this.trigger, 'click', () => {
			const self = this;

			navigator.permissions
				.query({ name: 'geolocation' })
				.then(function (result) {
					if (result.state == 'granted' || result.state == 'prompt') {
						navigator.geolocation.getCurrentPosition(
							(position) => {
								self.position.latitude = position.coords.latitude;
								self.position.longitude = position.coords.longitude;
								self.Cookies.set('currentLocation', JSON.stringify(self.position), { expires: 90 });
								if (self.useLoader) self.addLoader();

								const GEOCODING =
									'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
									self.position.latitude +
									',' +
									self.position.longitude +
									'&result_type=locality&language=en&key=' +
									self.key;

								const request = new Request(GEOCODING);

								fetch(request)
									.then((response) => response.json())
									.then((response) => {
										response.results.forEach((result, i) => {
											if (i === 0) {
												if (self.noSearch) {
													window.location = generateUrl()
												} else {
													const loc = result.formatted_address;
													const query = '?latitude=' +
													position.coords.latitude +
													'&longitude=' +
													position.coords.longitude +
													'&location=' +
													encodeURIComponent(loc)
													window.location = generateUrl(query)
												}
											} else {
												return '';
											}
										});
									})
									.catch((error) => {
										alert(error);
									});
							},
							() => {
								self.Cookies.set('currentLocation', 'denied', { expires: 90 });
								//handleLocationError(true);
							}
						);
					} else if (result.state == 'denied') {
						// Set the cookie to empty string.The access to location is denied and we shouldn't bother the user with multiple attempts
						self.Cookies.set('currentLocation', 'denied', { expires: 90 });
					}
					return 1;
				})
				.catch((error) => {
					console.log('Error: ' + error.message + ' found while waiting for the navigator permission state return.');
				});
		});
	}

	initGeolocation() {
		const queryString = new URLSearchParams(location.search);
		const foundParameters = this.getPositionParamsFromQueryString(queryString);

		let locationName;

		if (foundParameters && queryString.get('location')) {
			locationName = decodeURIComponent(queryString.get('location'));
			this.text.innerHTML = locationName;
		}
	}

	getPositionParamsFromQueryString(queryString) {
		if (queryString.get('latitude')) {
			this.position.latitude = queryString.get('latitude');
			this.position.longitude = queryString.get('longitude');
			return true;
		}
		return false;
	}

	initCookiesLib() {
		return import('js-cookie')
			.then(({ default: Cookies }) => {
				this.Cookies = Cookies;
				return this.Cookies;
			})
			.catch((error) => {
				console.log(error);
			});
	}

	addLoader() {
		document.body.className = 'lta-loader in-out-animation';
	}
}

export default LocationText;
